const alertSchema = {
	name: "alert",
	group: "block",
	content: "block+",
	attrs: {
		type: { default: null },
		title: { default: null },
	},
};

export default alertSchema;
